import { forwardRef } from 'react'
import styled from 'styled-components'

import { colors, fontSizes, fontWeights, transitions } from '@/styles'

const Wrapper = styled.div`
  height: ${props => props.height || 100}px;
  width: 100%;
  max-width: 100%;
  position: relative;
  margin-top: ${props => props.top || 0}px;
  margin-bottom: ${props => props.bottom || 0}px;
  border-radius: 6px;
`

const Control = styled.textarea`
  height: 100%;
  font-size: ${props =>
    props.fontSize ? `${props.fontSize}px` : fontSizes.regular};
  font-weight: ${props => props.fontWeight || fontWeights.regular};
  outline: none;
  letter-spacing: -0.39px;
  color: ${colors.regular};
  width: 100%;
  resize: none;
  transition: border-color ${transitions.ease};
  background: ${props => props.background || colors.white};

  padding: 15px;
  border-radius: 6px;
  border: 1px solid ${colors.grey};

  &:focus {
    border-color: ${colors.secondary};
  }
  &::placeholder {
    color: ${colors.mediumGrey};
    font-weight: ${fontWeights.regular};
  }

  ${props =>
    props.hasError &&
    `
    border-color: ${colors.red} !important;
  `}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

const Counter = styled.small`
  position: absolute;
  color: ${colors.regular};
  font-size: ${fontSizes.regular};
  letter-spacing: -0.39px;
  line-height: 22px;
  text-align: right;
  right: 7px;
  bottom: 5px;
  pointer-events: none;

  ${Control}:disabled + & {
    opacity: 0.3;
  }
`

const Textarea = forwardRef(
  ({ onChange, children, maxLength, hasError = false, ...rest }, ref) => {
    const handleChange = e => {
      if (maxLength && e.target.value.length > maxLength) {
        return
      }
      onChange(e)
    }
    return (
      <Wrapper
        ref={ref}
        top={rest.top}
        bottom={rest.bottom}
        height={rest.height}
        background={rest.background}
      >
        <Control {...rest} hasError={hasError} onChange={handleChange}>
          {children}
        </Control>
        {maxLength && (
          <Counter>
            {rest.value.length}/{maxLength}
          </Counter>
        )}
      </Wrapper>
    )
  }
)

Textarea.defaultProps = {
  value: ''
}

Textarea.displayName = 'Textarea'

export default Textarea
